import { render, staticRenderFns } from "./StructureTable.vue?vue&type=template&id=032ad092&scoped=true"
import script from "./StructureTable.vue?vue&type=script&lang=js"
export * from "./StructureTable.vue?vue&type=script&lang=js"
import style0 from "./StructureTable.vue?vue&type=style&index=0&id=032ad092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032ad092",
  null
  
)

export default component.exports